import { ActivityIndicator, View } from 'react-native'
import React, { type ComponentProps } from 'react'
import { mesaColorNames } from '@/src/common/theme'
import { isE2E } from '../environment'

export function Loading({ size }: Pick<ComponentProps<typeof ActivityIndicator>, 'size'>) {
  return (
    <View style={{ flex: 1, justifyContent: 'center' }}>
      {!isE2E && (
        <ActivityIndicator
          size={size ?? 'large'}
          color={mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9']}
        />
      )}
    </View>
  )
}
